// Entry point for the build script in your package.json

// Responsive embeds
import responsiveEmbeds from "./lib/responsiveEmbeds";
responsiveEmbeds();

// Grid overlay
import gridOverlay from "./lib/gridOverlay";
gridOverlay();

// React
import * as Tombolo from "tombolo";
import * as components from "./components";
Tombolo.start(components);

// Navigation
import navigation from "./features/navigation";
navigation();

import "./features/expandableBlocks";
